import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-primary d-flex align-items-center",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
    viewBox: "0 0 16 16",
    role: "img",
    "aria-label": "Warning:"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " An example alert with an icon ")
], -1)
const _hoisted_4 = { class: "col-12 bg-light p-3" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Countries", -1)
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table table-striped table-sm" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Country Code"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Currency Short Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Currency Standard Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Country Time zone"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Country Topic"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "ISO Code"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1)
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "btn-group mr-2" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/countries/create",
              class: "btn btn-sm btn-primary align-self-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Country")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: country.id
                  }, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(country.id), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(country.name), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(country.country_code), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(country.currency_short_name), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(country.curreny_standard_name), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(country.country_time_zone), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(country.country_topic), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(country.country_ios_code), 1),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_router_link, {
                          to: `/countries/${country.id}/edit`,
                          class: "btn btn-sm btn-secondary me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Edit")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("a", {
                          class: "btn btn-sm btn-danger me-2",
                          onClick: ($event: any) => ($setup.del(country.id))
                        }, " Delete", 8, _hoisted_21)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => ($setup.load($event)))
      ],
      pages: $setup.lastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"])
  ], 64))
}